import * as React from 'react';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';

function Heading(props) {
  return (
    <Typography component="h1" variant="h4" color="primary" gutterBottom>
      {props.children}
    </Typography>
  );
}

Heading.propTypes = {
  children: PropTypes.node,
};

export default Heading;